<div class="loot-modal-overlay d-flex align-items-center justify-content-center">
    
    <!-- Background Ambient Glow Stage -->
    <div class="radial-glow-stage" [class]="state() === 'reveal' ? getRarityClass(reward().rarity) : 'default'"></div>

    <!-- Floating Particles -->
    <div class="particles-container">
        <span class="particle p-1"></span>
        <span class="particle p-2"></span>
        <span class="particle p-3"></span>
        <span class="particle p-4"></span>
        <span class="particle p-5"></span>
        <span class="particle p-6"></span>
        <span class="particle p-7"></span>
        <span class="particle p-8"></span>
    </div>

    <!-- Main Opening Area -->
    <div class="stage-container d-flex flex-column align-items-center text-center">
        
        <!-- Closed Chest (Intro / Shaking states) -->
        @if (state() === 'idle' || state() === 'shaking') {
        <div class="chest-box-wrapper cursor-pointer" 
             [class.shaking]="state() === 'shaking'" 
             (click)="openChest()" 
             title="Click to Open Chest">
            <img src="images/featured/forge_chest.png" class="closed-chest-img" alt="Forge Loot Chest">
            <div class="ambient-shadow"></div>
            <div class="chest-underlight"></div>
        </div>
        
        <div class="opening-instructions mt-4 d-flex flex-column align-items-center">
            @if (state() === 'idle') {
            <h2 class="display-6 text-uppercase fw-extrabold text-white animate-pulse mb-3">Forge Chest Unlocked</h2>
            <button class="btn btn-unlock px-5 py-3 text-uppercase tracking-widest fw-black" (click)="openChest()">
                Unlock Chest
            </button>
            }@else {
            <h2 class="display-6 text-uppercase fw-extrabold text-warning animate-shake-text">Forging Reward...</h2>
            <p class="text-secondary small">Energy levels peaking</p>
            }
        </div>
        }

        <!-- Screen Flash Blast (fades out quickly) -->
        @if (state() === 'flash') {
        <div class="screen-flash"></div>
        }

        <!-- Revealed State (Card float + Opened chest background) -->
        @if (state() === 'reveal') {
        <div class="reward-reveal-stage d-flex flex-column align-items-center animate-reveal">
            
            <!-- Opened chest base placed below the floating card -->
            <div class="opened-chest-base mb-3 position-relative">
                <img src="images/featured/forge_chest.png" class="opened-chest-img" alt="Opened Chest">
                <div class="light-beam"></div>
            </div>

            <!-- Holographic Card Pop-out -->
            <div class="holographic-card" [class]="getRarityClass(reward().rarity)">
                
                <!-- Shiny Diagonal Sheen Layer -->
                <div class="card-sheen"></div>
                
                <!-- Inner Border Glow -->
                <div class="card-inner-glow"></div>

                <div class="card-content d-flex flex-column align-items-center justify-content-between p-4">
                    <div class="card-header-tag text-uppercase tracking-widest small fw-bold mb-2">
                        Unlocked Reward
                    </div>

                    <!-- Item Thumbnail -->
                    <div class="item-preview-box rounded-3 overflow-hidden shadow-inner mb-3">
                        <img [src]="reward().imageUrl" [alt]="reward().name" class="w-100 h-100 object-fit-cover">
                    </div>

                    <div class="item-details text-center">
                        <span class="badge text-uppercase tracking-widest px-2.5 py-1 mb-2 shadow-sm font-bold rarity-badge"
                            [class]="getRarityClass(reward().rarity)">
                            {{ reward().rarity }}
                        </span>
                        <h4 class="fw-black text-white text-uppercase tracking-wider mb-2 card-title-clamp">{{ reward().name }}</h4>
                        <p class="text-secondary small mb-0 card-desc-clamp">{{ reward().description }}</p>
                    </div>
                </div>
            </div>

            <!-- Claim Button -->
            <div class="claim-action-row mt-5">
                <button class="btn btn-claim btn-lg px-5 py-3 text-uppercase tracking-widest fw-black" 
                        [class]="getRarityClass(reward().rarity)"
                        (click)="claimReward()">
                    Claim Item
                </button>
            </div>
        </div>
        }

    </div>

</div>
